export function isSafari(): boolean {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
}

export function isApple(): boolean {
  return /(mac|iphone|ipod|ipad)/i.test(navigator.platform)
}

export function isIOSWebView(): boolean {
  const ua = navigator.userAgent
  return /iPhone|iPad|iPod/i.test(ua) && !isSafari()
}

export function isAndroidWebView(): boolean {
  const ua = navigator.userAgent
  return /Android/i.test(ua) && (/\bwv\b/.test(ua) || /Version\/\d+\.\d+/.test(ua))
}

export function isNativeWebView(): boolean {
  return isIOSWebView() || isAndroidWebView()
}

// HEIC декодируют только движки WebKit на Apple-устройствах: под iOS/iPadOS
// это любой браузер (все они на WebKit), под macOS — только Safari.
export function supportsHeic(): boolean {
  const ua = navigator.userAgent
  const isIOS =
    /iPhone|iPad|iPod/i.test(ua) ||
    (/mac/i.test(navigator.platform) && navigator.maxTouchPoints > 1)
  if (isIOS) return true
  return isApple() && isSafari()
}
